var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/communication/outline/call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 77",
    d: "M17.0621 16.0049V14.7538C17.0621 14.1322 16.6837 13.5733 16.1065 13.3424L14.5604 12.724C13.8264 12.4304 12.9898 12.7484 12.6362 13.4556L12.5017 13.7247C12.5017 13.7247 10.6015 13.3446 9.08138 11.8245C7.56124 10.3043 7.18121 8.40417 7.18121 8.40417L7.45028 8.26963C8.15742 7.91606 8.47549 7.07947 8.18187 6.34541L7.56344 4.79932C7.33258 4.22219 6.77361 3.84375 6.15202 3.84375H4.901C4.06145 3.84375 3.38086 4.52434 3.38086 5.36389C3.38086 12.0803 8.82557 17.525 15.542 17.525C16.3815 17.525 17.0621 16.8444 17.0621 16.0049Z",
    stroke: "white",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.fe9cc7c50db477c11ba415075c217cfb.svg";
export { ForwardRef as ReactComponent };